const config = {
  CaptchaAppId: "197368936",
  session_maxAge: 1000 * 60 * 120
}

export default config